import React from 'react';

import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { SummaryCardHelp } from '~/modules/common/components';

const ResourceHoursHelp = ({ type }) => {
  const intl = useIntl();

  const toolTipContent = content(intl, type);

  return <SummaryCardHelp content={toolTipContent} />;
};

const content = (intl, type) => {
  const hoursAlertId = `resourceHoursHelp.${type}HoursAlert`;
  const allocatedAlertId = `resourceHoursHelp.${type}AllocatedAlert`;

  return [
    {
      title: intl.formatMessage({ id: 'resourceHoursHelp.hours' }),
      message: intl.formatMessage({ id: hoursAlertId })
    },
    {
      title: intl.formatMessage({ id: 'resourceHoursHelp.allocated' }),
      message: intl.formatMessage({ id: allocatedAlertId })
    }
  ];
};

ResourceHoursHelp.propTypes = {
  type: PropTypes.string.isRequired
};

export default ResourceHoursHelp;
